/* tslint:disable */
/* eslint-disable */
import { API, graphqlOperation } from 'aws-amplify'
import { get } from 'lodash/fp'
// import * as Sentry from '@sentry/react'

import { slsAxios } from 'helpers'

export const graphQLQuery = async (query: string, queryName: string, options: any = {}) => {
  try {
    const res: any = await slsAxios.post('/graphql', graphqlOperation(query, options))
    const data = get(`data.data.${queryName}`, res)
    // checks for list queries vs individual item queries
    if (Array.isArray(res.data.errors) && res.data.errors.length > 0) {
      return console.error(res.data.errors)
    }
    if (data?.items) {
      if (queryName === 'userByEmail') {
        return data.items[0]
      }
      return data.items
    }
    return data
  } catch (error) {
    // Sentry.captureException(error)
  }
}

export const graphQLMutation = async (mutation: string, input: any, mutationName?: string, notInputObject?: any) => {
  try {
    const res: any = await slsAxios.post('/graphql', graphqlOperation(mutation, input ? { input } : notInputObject))
    if (mutationName) {
      return get(`data.data.${mutationName}`, res)
    }
    return res
  } catch (error) {
    // Sentry.captureException(error)
  }
}

export const graphQLSubscription = (subscription: string, options: any, callback: (d: any) => void) => {
  // ignoring for type issue with `.subscribe`
  // @ts-ignore
  return API.graphql(graphqlOperation(subscription, options)).subscribe({
    next: ({ value: { data } }) => callback(data),
    error: error => {
      console.log(error)
      // Sentry.captureException(error)
    }
  })
}
